import { render } from "./Button.vue?vue&type=template&id=015de462&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=015de462&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "015de462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('015de462', __exports__)) {
    api.reload('015de462', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=015de462&ts=true", () => {
    api.rerender('015de462', render)
  })

}


export default __exports__